// extracted by mini-css-extract-plugin
export default {"login_page":"LoginPage_login_page__g2RpL"};